import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.object.assign.js";
var _excluded = ["analyticsName", "loading", "onRequestPasswordlessLogin", "isRequestingPasswordlessLogin", "disabled", "actionText", "showForgotPassword", "openForgotPasswordInNewTab"];
function cov_k9wrez2bh() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/platform/auth/AccountFormControls.tsx";
  var hash = "9ba76a35cd0df3d3b05162456f279c05ca662efc";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/platform/auth/AccountFormControls.tsx",
    statementMap: {
      "0": {
        start: {
          line: 26,
          column: 65
        },
        end: {
          line: 69,
          column: 1
        }
      },
      "1": {
        start: {
          line: 37,
          column: 2
        },
        end: {
          line: 68,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 26,
            column: 65
          },
          end: {
            line: 26,
            column: 66
          }
        },
        loc: {
          start: {
            line: 36,
            column: 6
          },
          end: {
            line: 69,
            column: 1
          }
        },
        line: 36
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 33,
            column: 2
          },
          end: {
            line: 33,
            column: 27
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 33,
            column: 23
          },
          end: {
            line: 33,
            column: 27
          }
        }],
        line: 33
      },
      "1": {
        loc: {
          start: {
            line: 43,
            column: 15
          },
          end: {
            line: 43,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 43,
            column: 15
          },
          end: {
            line: 43,
            column: 25
          }
        }, {
          start: {
            line: 43,
            column: 29
          },
          end: {
            line: 43,
            column: 41
          }
        }],
        line: 43
      },
      "2": {
        loc: {
          start: {
            line: 47,
            column: 17
          },
          end: {
            line: 47,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 47,
            column: 17
          },
          end: {
            line: 47,
            column: 24
          }
        }, {
          start: {
            line: 47,
            column: 28
          },
          end: {
            line: 47,
            column: 58
          }
        }],
        line: 47
      },
      "3": {
        loc: {
          start: {
            line: 51,
            column: 7
          },
          end: {
            line: 66,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 51,
            column: 7
          },
          end: {
            line: 51,
            column: 25
          }
        }, {
          start: {
            line: 52,
            column: 8
          },
          end: {
            line: 65,
            column: 15
          }
        }],
        line: 51
      },
      "4": {
        loc: {
          start: {
            line: 56,
            column: 18
          },
          end: {
            line: 56,
            column: 65
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 56,
            column: 47
          },
          end: {
            line: 56,
            column: 55
          }
        }, {
          start: {
            line: 56,
            column: 58
          },
          end: {
            line: 56,
            column: 65
          }
        }],
        line: 56
      },
      "5": {
        loc: {
          start: {
            line: 58,
            column: 12
          },
          end: {
            line: 60,
            column: 49
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 59,
            column: 16
          },
          end: {
            line: 59,
            column: 48
          }
        }, {
          start: {
            line: 60,
            column: 16
          },
          end: {
            line: 60,
            column: 49
          }
        }],
        line: 58
      }
    },
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "9ba76a35cd0df3d3b05162456f279c05ca662efc"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_k9wrez2bh = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_k9wrez2bh();
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { Box, Button, Link } from '@opendoor/bricks-next';
import { t } from "../../i18n/translationHelper.mjs";
cov_k9wrez2bh().s[0]++;
var AccountFormControls = function AccountFormControls(_ref) {
  var analyticsName = _ref.analyticsName,
    loading = _ref.loading,
    onRequestPasswordlessLogin = _ref.onRequestPasswordlessLogin,
    isRequestingPasswordlessLogin = _ref.isRequestingPasswordlessLogin,
    disabled = _ref.disabled,
    actionText = _ref.actionText,
    _ref$showForgotPasswo = _ref.showForgotPassword,
    showForgotPassword = _ref$showForgotPasswo === void 0 ? (cov_k9wrez2bh().b[0][0]++, true) : _ref$showForgotPasswo,
    openForgotPasswordInNewTab = _ref.openForgotPasswordInNewTab,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_k9wrez2bh().f[0]++;
  cov_k9wrez2bh().s[1]++;
  return /*#__PURE__*/React.createElement(Box, {
    gap: "$20x"
  }, /*#__PURE__*/React.createElement(Button, _extends({
    testID: "account-form-submit-button",
    variant: "primary",
    type: "submit",
    label: (cov_k9wrez2bh().b[1][0]++, actionText) || (cov_k9wrez2bh().b[1][1]++, t('confirm')),
    size: "medium",
    analyticsName: "".concat(analyticsName, "-account-form-control-action-button"),
    width: "100%",
    loading: (cov_k9wrez2bh().b[2][0]++, loading) && (cov_k9wrez2bh().b[2][1]++, !isRequestingPasswordlessLogin)
  }, props.submitA11yProps, {
    disabled: disabled
  })), (cov_k9wrez2bh().b[3][0]++, showForgotPassword) && (cov_k9wrez2bh().b[3][1]++, /*#__PURE__*/React.createElement(Link, {
    variant: "primary",
    href: "/reset-password",
    analyticsName: "".concat(analyticsName, "-forgot-password"),
    target: openForgotPasswordInNewTab ? (cov_k9wrez2bh().b[4][0]++, '_blank') : (cov_k9wrez2bh().b[4][1]++, '_self'),
    "aria-label": openForgotPasswordInNewTab ? (cov_k9wrez2bh().b[5][0]++, t('forgotPasswordAriaNewWindow')) : (cov_k9wrez2bh().b[5][1]++, t('forgotPasswordAriaSameWindow')),
    margin: "auto"
  }, t('forgotPassword'))));
};
export default AccountFormControls;
//# sourceMappingURL=AccountFormControls.mjs.map